const STAFF_EMAIL_DOMAINS = ["platform.sh", "upsun.com", "ext.platform.sh"];

export const isInternalUser = (email: string = "") => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (regex.test(email)) {
    const domain = email.split("@")[1];
    return STAFF_EMAIL_DOMAINS.includes(domain);
  }
  return false;
};
